<template>
    <div class="min-h-screen font-inter">
      <main class="w-full">
        <AwaitingApprovalComponent />
      </main>
    </div>
</template>

<script>
    import { useRouter } from 'vue-router'
    import AwaitingApprovalComponent from '@/components/auth/AwaitingApprovalComponent.vue';

    export default {
      name: 'AwaitingApprovalView',
      data() {
        return {
        }
      },
      components: {
        AwaitingApprovalComponent,
      },
      setup() {
        const router = useRouter()
        return { router }
      },
      methods: {
      },
      mounted() {
        window.scrollTo(0, 0);
      },
    }
  </script>
  
  <style scoped>

  </style>
  
    